var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0822 23.5305C9.81135 23.8187 9.54504 24.0982 9.34263 24.3031L8.82555 23.7861V23.8376C4.58062 19.6762 1.05795 14.0264 1.20774 8.13476L1.20774 8.13466C1.33013 3.28435 6.06021 -0.316535 10.7842 0.660629L10.7845 0.660677C14.8897 1.50778 18.1285 5.45198 17.8702 9.62363L17.8702 9.62392C17.586 14.2578 14.4993 18.5848 11.4192 22.0767C11.3816 22.1186 11.3565 22.1478 11.3361 22.1716C11.3087 22.2035 11.2898 22.2255 11.2604 22.2549L11.2461 22.2693L11.233 22.2847C11.2329 22.2848 11.2321 22.2857 11.2306 22.2874L11.2231 22.2959L11.1978 22.3243C11.1768 22.3476 11.1488 22.3785 11.1146 22.4161C11.0462 22.4912 10.9544 22.5915 10.847 22.7081C10.6322 22.9414 10.3561 23.2391 10.0822 23.5305Z",
    stroke: "#255097"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0093 8.95582C14.0093 11.4199 12.0117 13.4175 9.54762 13.4175C7.0835 13.4175 5.08594 11.4199 5.08594 8.95582C5.08594 6.4917 7.0835 4.49414 9.54762 4.49414C12.0117 4.49414 14.0093 6.4917 14.0093 8.95582Z",
    stroke: "#255097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimary);
export default __webpack_public_path__ + "static/media/primary.2d4c9d1037e6d99ee2d6da9c1f67238e.svg";
export { ForwardRef as ReactComponent };